import { render } from "./TheLogo.vue?vue&type=template&id=d18b174a&ts=true"
import script from "./TheLogo.vue?vue&type=script&lang=ts"
export * from "./TheLogo.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__